/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
import * as i0 from "@angular/core";
import * as i1 from "./memory-leak-tracking.component";
import * as i2 from "./error-tracking.service";
var styles_MemoryLeakTrackingComponent = [];
var RenderType_MemoryLeakTrackingComponent = i0.ɵcrt({ encapsulation: 2, styles: styles_MemoryLeakTrackingComponent, data: {} });
export { RenderType_MemoryLeakTrackingComponent as RenderType_MemoryLeakTrackingComponent };
export function View_MemoryLeakTrackingComponent_0(_l) { return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, 0, null, null, 0, null, null, null, null, null, null, null))], null, null); }
export function View_MemoryLeakTrackingComponent_Host_0(_l) { return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, 0, null, null, 1, "fl-memory-leak-tracking", [], null, null, null, View_MemoryLeakTrackingComponent_0, RenderType_MemoryLeakTrackingComponent)), i0.ɵdid(1, 114688, null, 0, i1.MemoryLeakTrackingComponent, [i2.ErrorTracking, i0.NgZone], null, null)], function (_ck, _v) { _ck(_v, 1, 0); }, null); }
var MemoryLeakTrackingComponentNgFactory = i0.ɵccf("fl-memory-leak-tracking", i1.MemoryLeakTrackingComponent, View_MemoryLeakTrackingComponent_Host_0, {}, {}, []);
export { MemoryLeakTrackingComponentNgFactory as MemoryLeakTrackingComponentNgFactory };



// WEBPACK FOOTER //
// ./src/@freelancer/tracking/memory-leak-tracking.component.ngfactory.js.pre-build-optimizer.js